import { useHashChangeSmoothScroll } from '@websrc/App/Hooks/hashChangeSmoothScroll'
import { usePath } from '@websrc/App/Hooks/usePath'
import { mapTeacherHubNavigation } from '@websrc/DataMappers/mapTeacherHubNavigation'
import clsx from 'clsx'
import { Link } from 'gatsby'
import { box, listItem, rule, styles } from 'leds'
import React, { FC } from 'react'

export type SidebarSubItemProps = {
  item: ReturnType<typeof mapTeacherHubNavigation>['items'][0]
}

export const SidebarSubItem: FC<SidebarSubItemProps> = ({ item }) => {
  const path = usePath()
  const setHash = useHashChangeSmoothScroll()
  const selected = item.url === path

  return (
    <li className={styles({ overflowY: 'hidden' })}>
      <div className={listItem({ level: 'second' })}>
        <span className={box({ type: 'icon' })}>
          <hr
            className={clsx(
              styles({ height: 'full' }),
              rule({
                direction: 'vertical',
                background: selected ? 'blue5' : 'grey5',
              })
            )}
          />
        </span>
        <span
          className={styles({
            paddingLeft: 10,
            color: selected ? 'blue5' : 'black',
          })}
          data-testid={`selected-${selected}`}
        >
          <Link to={item.url}>{item.label}</Link>
        </span>
      </div>
      {item.items && selected && (
        <ul className={styles({ listStyle: 'none', padding: 0 })}>
          {item.items.map((it, k) => {
            const subItemSelected = it.url === decodeURIComponent(window.location.hash)

            return (
              <li key={k}>
                <div className={listItem({ level: 'second' })}>
                  <span className={box({ type: 'icon' })}>
                    <hr
                      className={clsx(
                        styles({ height: 'full' }),
                        rule({ direction: 'vertical', background: 'blue5' })
                      )}
                    />
                  </span>
                  <span
                    className={styles({
                      paddingLeft: 30,
                      color: subItemSelected ? 'blue5' : 'black',
                    })}
                    data-testid={`selected-${subItemSelected}`}
                  >
                    <a
                      href={it.url}
                      onClick={(e) => {
                        e.preventDefault()
                        setHash(it.url)
                      }}
                    >
                      {it.label}
                    </a>
                  </span>
                </div>
              </li>
            )
          })}
        </ul>
      )}
    </li>
  )
}
